import React from 'react';
import NgReports from 'components/business/NgReports';

export const ReportsCtx = React.createContext({});

function ReportsPageProvider(props) {
  const ctx = {
  };
  return (
    <ReportsCtx.Provider value={ ctx }>
      {props.children}
    </ReportsCtx.Provider>
  );
}

function NgReportsPage() {
  return (
    <ReportsPageProvider>
      <NgReports />
    </ReportsPageProvider>
  );
}

export default NgReportsPage;
